import React, { useEffect } from "react";
import BaseLayout from "../../components/BaseLayout";
import HeaderBaseLayout from "../../components/HeaderBaseLayout";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { Col, Row, Card } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApiUtils from "../../utils/api_utils";
import "./style.scss";

const QuizPage = (props) => {
  const navigate = useNavigate();
  const { getQuizCategory, pwa_setting, quizCategory } = props;

  useEffect(() => {
    getQuizCategory();
  }, []);

  const handleClickQuiz = (id) => {
    navigate(PageRoutes.quiz + `/${id}`);
  };

  return (
    <BaseLayout
      show_menu={pwa_setting.show_main_menu}
      isCustom={true}
      header={
        <HeaderBaseLayout
          src={Assets.iconBackWhite}
          title="Quiz"
          onClick={() => navigate(PageRoutes.home)}
        />
      }
    >
      <Row className="quiz-content">
        {quizCategory &&
          quizCategory.map((a, index) => (
            <Col xs={6} sm={6} md={6} className="content-wrapper" key={index}>
              <Card
                className="card-category"
                onClick={() => handleClickQuiz(a.id)}
              >
                <img
                  src={ApiUtils.validateImgUrl({ url: a.image_pic_url })}
                  alt="logo_image"
                />
                <span className="quiz-title">{a.name}</span>
                <span className="quiz-count">{a.total_quiz} Quizzes</span>
              </Card>
            </Col>
          ))}
      </Row>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
  quizCategory: state.QuizSM.quizCategory,
});

const mapDispatchToProps = (dispatch) => ({
  getQuizCategory: dispatch.QuizSM.getQuizCategory,
});

export default connect(mapStateToProps, mapDispatchToProps)(QuizPage);
